import { GetServerSideProps, NextPage } from 'next';
import { destroyCookie, parseCookies, setCookie } from 'nookies';

import AddressService from '@/domain/address/services/implementations/AddressService';
import { httpClient } from '@/infra/AxiosHttpClient';
import { PreviousLogin } from '@/presentation/PreviousLogin';
import { cleanCookiesSSR } from '@/shared/utils/cookie';

const Previous: NextPage = () => <PreviousLogin />;

export const getServerSideProps: GetServerSideProps = async context => {
  const {
    'fapp.address': addressToken,
    'fapp.accessToken': acessToken,
    'fapp.refreshToken': refreshToken,
  } = parseCookies(context);

  const addressService = new AddressService(
    httpClient({
      baseURL: process.env.API_CUSTOMER_URL as string,
      ctx: context,
    }),
  );

  if (acessToken && refreshToken) {
    try {
      const userAddresses = await addressService.readAddress();

      if (userAddresses.length && !addressToken) {
        destroyCookie(context, 'fapp.address');

        setCookie(
          context,
          'fapp.address',
          encodeURIComponent(JSON.stringify(userAddresses[0])),
          {
            expires: new Date(2100, 31, 12),
          },
        );

        return {
          redirect: {
            permanent: false,
            destination: '/home',
          },
          props: {},
        };
      }
    } catch (error) {
      cleanCookiesSSR(context);

      return {
        redirect: {
          permanent: false,
          destination: '/',
        },
        props: {},
      };
    }
  }

  if (addressToken) {
    return {
      redirect: {
        permanent: false,
        destination: '/home',
      },
      props: {},
    };
  }

  return {
    props: {},
  };
};

export default Previous;
